export const OWNER_INFO = {
  ownerInfoFields: [
    {
      label: 'Full Name',
      name: 'owner.fullName',
      type: 'text',
    },
    {
      label: 'Phone',
      name: 'owner.phone',
      type: 'tel',
    },
    {
      label: 'Email',
      name: 'owner.email',
      type: 'email',
    },
  ],
  mailAddressFields: {
    street: 'owner.mailAddr.street',
    city: 'owner.mailAddr.city',
    state: 'owner.mailAddr.state',
    zip: 'owner.mailAddr.zip',
  },
  serialNumberField: {
    label: 'Property Serial Number',
    name: 'owner.serialNumber',
    type: 'text',
  },
  additionalSerialNumbersField: {
    label: 'Additional Property Serial Numbers (Optional)',
    name: 'owner.additionalSerialNumbers',
    multiline: true,
    placeholder: 'Enter additional serial numbers, separated by commas...',
    rows: 2,
    type: 'text',
    variant: 'outlined',
  },
  statementField: {
    label: `Owner's statement of circumstances`,
    name: 'owner.statement',
    multiline: true,
    placeholder: 'Enter statement here...',
    rows: 6,
    type: 'text',
    variant: 'outlined',
  },
};
